import axios from "axios";
import { API_BASE_URL } from "./config";
const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
});
service.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
service.interceptors.response.use((response) => {
    const res = response.data;
    // 只有明确返回了非200的code才视为业务错误
    if (res.code !== undefined && res.code !== 200) {
        const msg = res.message || "请求失败";
        return Promise.reject(new Error(msg));
    }
    return res;
}, (error) => {
    // 网络/HTTP 错误处理
    let msg = "网络错误";
    if (error.response && error.response.data) {
        const data = error.response.data;
        if (typeof data === "object") {
            msg = data.message || data.msg || msg;
        }
        else if (typeof data === "string") {
            // 有些后端返回纯文本错误，避免把长HTML塞进ElMessage
            msg = data.length > 200 ? "服务器异常" : data;
        }
    }
    else if (error.message) {
        msg = error.message;
    }
    return Promise.reject(new Error(msg));
});
const request = {
    get(url, params, config) {
        return service.get(url, { params, ...config });
    },
    post(url, data, config) {
        return service.post(url, data, config);
    },
    put(url, data, config) {
        return service.put(url, data, config);
    },
    delete(url, params, config) {
        return service.delete(url, { params, ...config });
    },
    patch(url, data, config) {
        return service.patch(url, data, config);
    },
};
export default request;
export { service };
